(function(angular) {
    'use strict';

    var constantsObj = {
        ALERT_TYPES: {
            SUCCESS: 0,
            FAILURE: 1,
            WARNING: 2
        },
        CLIENT_CONSTANTS: {
            DEFAULT_CATEGORY: {
                'id': "631550000849",
                'name': "BUSINESS TRAVEL"
            }
        }
    };
    
    angular
        .module('SMART2')
        .constant("CONSTANTS", constantsObj);

})(angular);
